export default {
    m: 'Homme',
    w: 'Femme',
};
